export function createWorkExperienceHandling(data, setData) {
  function addOrUpdateExperience(experience) {
    const newData = { ...data };
    const index = newData.workExperiences.findIndex(
      (e) => e.id === experience.id
    );
    if (index >= 0) {
      newData.workExperiences[index] = experience;
    } else {
      newData.workExperiences.push(experience);
    }
    setData(newData);
  }

  function deleteExperience(experience) {
    const newData = { ...data };
    const index = newData.workExperiences.findIndex(
      (e) => e.id === experience.id
    );
    if (index >= 0) {
      data.workExperiences.splice(index, 1);
      setData(newData);
    }
  }

  return { addOrUpdateExperience, deleteExperience };
}
